var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3636 8.72727H17.4545V9.81818H16.3636V8.72727Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.27273V19.6364H24V0H3.27273L0 3.27273ZM8.72621 3.27283V5.45461H15.2717V3.27283H8.72621ZM6.54545 6.54545L4.36364 8.72721V14.1818H7.63636V12H16.3636V14.1818H19.6364V8.72721L17.4545 6.54545H6.54545ZM7.63636 16.3637L9.81818 13.0909H14.1818L16.3636 16.3637H7.63636Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinting);
export default __webpack_public_path__ + "static/media/Printing.054baab7b63214eac52e29c243e19432.svg";
export { ForwardRef as ReactComponent };